import script from "./fileDropZone.vue?vue&type=script&setup=true&lang=js"
export * from "./fileDropZone.vue?vue&type=script&setup=true&lang=js"

import "./fileDropZone.vue?vue&type=style&index=0&id=99e15626&lang=scss"

const __exports__ = script;

export default __exports__